"use client";
import React, { useState } from "react";

import { Card } from "antd";

import { GENERAL_TEXT } from "@/lib/constants";
import { logoSvg, logoSvg2 } from "@/lib/imageIcon";

import HeaderModal from "../modal/headermodal";

const Calculation = ({ item }) => {
  const [showModal, setShowModal] = useState(false);
  const [toggle, setToggle] = useState({
    calculator: false,
    portfolio: false,
    watchlist: false,
  });

  const handleOnClick = (buttonText) => {
    setShowModal(true);
    setToggle({
      calculator: buttonText === GENERAL_TEXT.RETIREMENT_CALCULATOR,
      portfolio: buttonText === GENERAL_TEXT.PORTFOLIO_TRACKER,
      watchlist: buttonText === GENERAL_TEXT.WATCHLIST,
    });
  };
  return (
    <div>
      <HeaderModal
        toggle={toggle}
        setToggle={setToggle}
        setShowModal={setShowModal}
        showModal={showModal}
      />
      <div className="p-0 m-0">
        <Card className="common-card">
          <div className="blue-card_header p-0 d-flex">
            <img
              src={logoSvg}
              alt="TYKR Logo"
              width={100}
              height={55}
              className="cursor-pointer mr-48"
            />
          </div>
          <img
            src={logoSvg2}
            alt="Logo"
            width={120}
            height={120}
            className="background-image"
          />
          <div className="blue-card-body">
            <div className="d-flex flex-column justify-content-center">
              <span className="blue-card-body-span">{item?.title}</span>
              <div className="d-flex justify-content-center">
                <div
                  className="green-search-command text-align-center mt-24 cursor-pointer"
                  onClick={() => handleOnClick(item?.buttonText)}
                >
                  {item?.buttonText}
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Calculation;
